import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GradientText } from '../components/ui/gradient-text';

const PLANS = {
  inbox: {
    name: 'Social Media Inbox',
    price: 49,
    features: [
      'Instagram DM Management',
      'Message Templates',
      'Quick Replies',
      'Basic Analytics'
    ],
    chargebeeUrl: 'https://followerstransactions-test.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=Social-Media-Inbox-USD-Monthly&utm_source=cb-app-copy'
  },
  scheduler: {
    name: 'Post Scheduler',
    price: 99,
    features: [
      'Content Calendar',
      'Auto-posting',
      'Media Library',
      'Advanced Analytics'
    ],
    chargebeeUrl: 'https://followerstransactions-test.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=Post-Scheduler-USD-Monthly&utm_source=cb-app-copy'
  },
  all: {
    name: 'All Features',
    price: 149,
    features: [
      'All Inbox Features',
      'All Scheduler Features',
      'Priority Support',
      'Early Access to New Features'
    ],
    chargebeeUrl: 'https://followerstransactions-test.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=All-Packages-USD-Monthly&utm_source=cb-app-copy'
  }
};

export default function Pricing() {
  const navigate = useNavigate();

  const handlePlanSelect = (chargebeeUrl: string) => {
    window.location.href = chargebeeUrl;
  };

  return (
    <div className="py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <GradientText
          colors={["#0ea5e9", "#6366f1", "#0ea5e9", "#6366f1"]}
          animationSpeed={4}
          className="text-4xl font-bold"
        >
          Simple, Transparent Pricing
        </GradientText>
        <p className="mt-4 text-xl text-gray-600">
          Choose the plan that best fits your needs
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
        {Object.entries(PLANS).map(([key, plan]) => (
          <div
            key={key}
            className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 transition-all duration-200 hover:shadow-lg"
          >
            <h3 className="text-2xl font-semibold text-gray-900">{plan.name}</h3>
            <p className="mt-4 text-gray-600">Starting from</p>
            <div className="mt-2 flex items-baseline">
              <span className="text-5xl font-bold text-gray-900">${plan.price}</span>
              <span className="ml-2 text-gray-600">/month</span>
            </div>

            <ul className="mt-8 space-y-4">
              {plan.features.map((feature, index) => (
                <li key={index} className="flex items-center">
                  <svg
                    className="h-5 w-5 text-green-500"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path d="M5 13l4 4L19 7"></path>
                  </svg>
                  <span className="ml-3 text-gray-700">{feature}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={() => handlePlanSelect(plan.chargebeeUrl)}
              className="mt-8 w-full bg-primary-600 text-white rounded-full py-3 px-6 hover:bg-primary-700 transition-colors duration-200"
            >
              Subscribe Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}